import { useMutation, useQueryClient } from "@tanstack/react-query"

import { updateCriteria } from "../../services/criteria";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useUpdateCriteria = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateCriteria,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (statusCode) => {
            if (statusCode === 200) {
                queryClient.invalidateQueries({ queryKey: ["criteria-groups"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Criteria updated successfully")
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    })
}

export default useUpdateCriteria;